<template>
    <div v-bind:class="[`product-family__product-card`, portfolio && `product-family__product-card--${portfolio}`]">
        <a :href="productDetailUrl" v-bind:class="[`product-family__product-card-link`, isFinishImageMissing ? `state-finish-image-missing` : ``]">
            <div class="product-family__img-wrap">
                <img v-if="primaryImageUrl" :src="`${primaryImageUrl}?wid=300&hei=300`" :alt="productDisplayName" class="product-family__product-card-image" />
                <div v-if="isFinishImageMissing" class="product-family__finish-coming-soon">{{ translations.NoVariantImage }}</div>
            </div>
            <div class="product-family__product-card-name">
                {{ productDisplayName }}
            </div>
        </a>
    </div>
</template>

<script lang="ts">
import { IProductFamilyTranslations } from 'Vue/interfaces/Interfaces';

export default {
    name: 'Product',
    props: {
        productDisplayName: {
            type: String,
        },
        productDetailUrl: {
            type: String,
        },
        primaryImageUrl: {
            type: String,
        },
        isFinishImageMissing: {
            type: Boolean,
        },
        portfolio: {
            type: String,
        },
        translations: {
            type: Object,
            default: {} as IProductFamilyTranslations,
        },
    },
};
</script>
